import { useQuery } from "@tanstack/react-query";
import { useContext, useMemo } from "react";
import { Controller } from "react-hook-form";
import ReactSelect from "react-select";
import BorseContext from "../context/borse";
import UserContext from "../context/user";
import Icon from "./icon";

const UserLocationAutocompleteQuestion = ({ name, control, required, readOnlyMode, customPh }) => {
  const { callApi } = useContext(UserContext);
  const { labels } = useContext(BorseContext);

  const {
    data: locations,
    isFetching,
    isError,
  } = useQuery(["user-locations"], () => callApi("/scholarship/userLocation"));

  const options = useMemo(
    () => (isFetching ? [] : locations?.map((location, i) => ({ value: i, label: location }))),
    [isFetching, locations]
  );

  return isError ? (
    <div className="form__error text-center">
      {labels?.WELFARE_ERROR_GENERIC || "An unexpected error occurred"}
    </div>
  ) : (
    <Controller
      name={name}
      control={control}
      rules={{ required }}
      render={({ field: { onChange, value, ...others } }) => (
        <ReactSelect
          {...others}
          onChange={(x) => onChange(x.label)}
          value={options.find((opt) => opt.label === value)}
          options={options}
          className="survey__select"
          classNamePrefix="survey-select"
          aria-label="survey-dropdown-select"
          placeholder={customPh || labels?.WELFARE_SELECT_PLACEHOLDER || "Select..."}
          components={{
            IndicatorSeparator: () => null,
            DropdownIndicator: () => <Icon name="angle-down" />,
          }}
          isDisabled={readOnlyMode}
        />
      )}
    ></Controller>
  );
};

export default UserLocationAutocompleteQuestion;
